import { useTranslation } from 'react-i18next'

import styles from './PendingCallLabel.module.scss'

export const PendingCallLabel = () => {
  const { t } = useTranslation()

  return <span className={styles.root}>{t('meetings.callingLabel')}</span>
}
